export default function cleanTitleFromFormatting (title) {
  if (!title) return ''

  return title
    .replace(/^[\s#]+/, '')
    .trim()
}
